import { render, staticRenderFns } from "./ScotiaPaymentGateway.vue?vue&type=template&id=40d4984a&scoped=true&"
import script from "./ScotiaPaymentGateway.vue?vue&type=script&lang=js&"
export * from "./ScotiaPaymentGateway.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../Github/lmsv4_web_frontend_vue/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40d4984a",
  null
  
)

export default component.exports